// @flow
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import ConnectionAccountRow, { type Props as ProviderTokenRowProps } from './ConnectionAccountRow'
import getJson from '../services/getJson'

type WebAnalyticsRowProps = {|
  provider: string,
  providerTitle: string,
  isConnected: boolean,
  connectedText: string,
  getTokenUrl: string,
  getTokenTitle: string
|}

type Props = {|
  providerTokenRows: Array<ProviderTokenRowProps>,
  webAnalyticsTokenRows: Array<WebAnalyticsRowProps>
|}

const getProviderTokensPath = '/api/v1/provider_tokens'

const t = {
  provider: 'Рекламная сеть',
  login: 'Логин',
  account: 'Кабинет'
}

export default function ConnectionAccountTable() {
  const [props, setProps] = useState<Props>({ providerTokenRows: [], webAnalyticsTokenRows: [] })

  useEffect(() => {
    getJson(getProviderTokensPath).done((response) => {
      setProps(response.data)
    })
  }, [])

  return (
    <table className="main-table">
      <colgroup>
        <col className="connection-table__column_provider" />
        <col className="connection-table__column_login" />
        <col className="connection-table__column_actions" />
      </colgroup>
      <thead>
        <tr className="main-table__header-row">
          <td className="main-table__header-cell main-table__header-cell_align-left">
            {t.provider}
          </td>
          <td className="main-table__header-cell main-table__header-cell_align-left">{t.login}</td>
          <td className="main-table__header-cell main-table__header-cell_align-left">
            {t.account}
          </td>
        </tr>
      </thead>
      <tbody>
        {_.map(props.providerTokenRows, (row) => (
          <ConnectionAccountRow
            key={row.provider}
            {...row}
            onReload={() => {
              getJson(getProviderTokensPath)
                .done((response) => {
                  setProps(response.data)
                })
                .fail(() => {
                  window.alert('Some error occured. Contact support')
                })
            }}
          />
        ))}
        {_.map(props.webAnalyticsTokenRows, (row) => (
          <tr key={row.provider} className={`main-table__body-row ${row.provider}-provider`}>
            <td className="main-table__cell">{row.providerTitle}</td>
            <td className="main-table__cell" />
            {renderWebAnalyticsCell(row)}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

function renderWebAnalyticsCell(row: WebAnalyticsRowProps) {
  if (row.isConnected) {
    return <td className="main-table__cell">{row.connectedText}</td>
  }

  return (
    <td className="main-table__cell">
      <a href={row.getTokenUrl} className="top-info__button top-info__button_no-ml">
        {row.getTokenTitle}
      </a>
    </td>
  )
}
